var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lock"},[_c('img',{staticClass:"lock-img",attrs:{"src":require("@/assets/img/policy/lock.png")}}),_c('p',[_vm._v(_vm._s(_vm.$t('permissionTip')))]),_c('p',[_vm._v(_vm._s(_vm.$t('permissionContact')))])])}
var staticRenderFns = []

export { render, staticRenderFns }